export default "__VITE_ASSET__B$2bUt6c__"